import {block} from '../utils/cn';

export const b = block('definition-list');
